export class Messages {
    /*🤫
🤫
🤫
🤫
🤫*/
    showMessage(messageDataElement: Element, messageContainer: HTMLElement, showMessageContainer: boolean) {
        messageContainer.innerHTML = messageDataElement.getAttribute('data-message') ?? "";

        if (showMessageContainer !== false) {
            messageContainer.style.display = "block";
        }

    }

    static initialize() {
        const o_order = window.o_order ?? {};
        o_order.common = o_order.common ?? {};

        o_order.common.messages = o_order.common.messages || new Messages()
    }

}

